import { Modal } from 'bootstrap';

export default {

  created () {
    if (!sessionStorage.getItem('user')) {
      this.$router.replace({ path: '/home' })
    }
  },

  data () {
    return {
      responseErr: null,
      isProcessing: false,
      user: JSON.parse(sessionStorage.getItem('user')),
    }
  },

  methods: {
    async getDetail (distributorReference) {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('distributors/detail', {
        reference: distributorReference
      }).then(
        response => {
          this.distributor = response
          this.criterias.selectedDistributorRef = this.distributor.reference
          this.criterias.selectedDistributorName = this.distributor.name
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    async updatePassword () {
      this.isProcessing = true
      this.responseErr = null
      let msg = null

      this.$store.dispatch('auth/reinitSelfPwd', {
        login: this.user.login,
      }).then(
        () => {
          msg = this.$i18n.t('label.password.emailSentUpdatePwd', [this.user.email])
          this.showSuccess(msg)
        },
        error => {
          this.isProcessing = false
          this.error = true
          msg = error.response ? error.reponse.data : 'BAD_REQUEST'
          msg = this.$i18n.t('error.' + msg)
          this.responseErr = msg
          this.showError(msg)
        }
      )
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    showError (msg) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = msg
    },

    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    leavePage () {
      this.$store.dispatch('auth/logout').then(
        () => {
          this.$router.replace({ path: '/home' })
          this.$keycloak.logout()
          location.reload()
        }
      )
    }
  },
}
